import { APP_API_URL, APP_API_URL_V2 } from '../../utils/xhr-instance';
import axiosInstance, { axiosInstanceV2 } from '../axios';

export async function create_purchase_receive(body) {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.post(
			`${APP_API_URL}/purchase-receive/create-purchase-receive`,
			body,
			{
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data;
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
}

export async function update_purchase_receive(body) {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.put(
			`${APP_API_URL}/purchase-receive/update-purchase-receive`,
			body,
			{
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data;
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
}
export async function updatePurchaseReceiveStatus(body) {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.post(
			`${APP_API_URL}/purchase-receive/update-status`,
			body,
			{
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token}`,
				},
			},
		);
		if (data?.success === false) {
			throw new Error(data?.message);
		}
		return data;
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
}

export const fetchPurchaseReceive = async (params) => {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.get(
			`${APP_API_URL}/purchase-receive/get-purchase-receive`,
			{
				params,
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data.data;
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
};

export const getPurchaseReceives = async (params) => {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstanceV2.get(`${APP_API_URL_V2}/purchase/receives/list`, {
			params,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return data.data;
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
};

export const getPurchaseReceiveDetails = async (id) => {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstanceV2.get(
			`${APP_API_URL_V2}/purchase/receives/details/${id}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data.data;
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
};

export async function sendEmail(body) {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.post(`${APP_API_URL}/purchase-receive/send-email`, body, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
		});
		return data;
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
}

export async function generatePurchaseReceivePdf(id, merge = false) {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstanceV2.get(
			`${APP_API_URL_V2}/purchase/receives/generate-pdf?ids=${id}&merge=${merge}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data?.data.signed_urls[0];
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
}
